import React from 'react';
import { InboxIcon, CalendarIcon, MailIcon, ClockIcon, CheckCircleIcon, AlertTriangleIcon, UserIcon, TrendingUpIcon, TrendingDownIcon } from 'lucide-react';
interface KPICardProps {
  title: string;
  value: string | number;
  icon: React.ElementType;
  iconColorClass: string;
  trend: number;
  trendLabel: string;
}
function KPICard({
  title,
  value,
  icon: Icon,
  iconColorClass,
  trend,
  trendLabel
}: KPICardProps) {
  const isPositiveTrend = trend >= 0;
  // For some metrics like response time, lower is better. We'll simplify and just show red/green based on the metric context.
  // Assuming positive trend number is "increase", negative is "decrease".
  // We'll pass the color directly or compute it. Let's compute a simple color:
  const trendColor = title.includes('Time') || title.includes('Overdue') ? isPositiveTrend ? 'text-red-600' : 'text-green-600' : isPositiveTrend ? 'text-green-600' : 'text-red-600';
  return <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-5 flex flex-col" data-id="element-32">
      <div className="flex justify-between items-start mb-4" data-id="element-33">
        <div className={`p-3 rounded-full ${iconColorClass}`} data-id="element-34">
          <Icon className="w-6 h-6" data-id="element-35" />
        </div>
        <div className={`flex items-center text-sm font-medium ${trendColor}`} data-id="element-36">
          {isPositiveTrend ? <TrendingUpIcon className="w-4 h-4 mr-1" data-id="element-37" /> : <TrendingDownIcon className="w-4 h-4 mr-1" data-id="element-38" />}
          {Math.abs(trend)}%
        </div>
      </div>
      <div data-id="element-39">
        <h3 className="text-gray-500 text-sm font-medium mb-1" data-id="element-40">{title}</h3>
        <div className="text-2xl font-bold text-gray-900" data-id="element-41">{value}</div>
        <p className="text-xs text-gray-400 mt-1" data-id="element-42">{trendLabel}</p>
      </div>
    </div>;
}
export function KPICards() {
  const kpis = [{
    title: 'Total Open Tickets',
    value: '142',
    icon: InboxIcon,
    iconColorClass: 'bg-blue-100 text-blue-600',
    trend: 5,
    trendLabel: 'vs last week'
  }, {
    title: 'Received Today',
    value: '48',
    icon: CalendarIcon,
    iconColorClass: 'bg-indigo-100 text-indigo-600',
    trend: 12,
    trendLabel: 'vs yesterday'
  }, {
    title: 'Received via Email',
    value: '32',
    icon: MailIcon,
    iconColorClass: 'bg-violet-100 text-violet-600',
    trend: -2,
    trendLabel: 'vs yesterday'
  }, {
    title: 'Avg First Response',
    value: '18m',
    icon: ClockIcon,
    iconColorClass: 'bg-cyan-100 text-cyan-600',
    trend: -15,
    trendLabel: 'vs last week'
  }, {
    title: 'Avg Resolution Time',
    value: '4.2h',
    icon: CheckCircleIcon,
    iconColorClass: 'bg-teal-100 text-teal-600',
    trend: -8,
    trendLabel: 'vs last week'
  }, {
    title: 'Overdue / At Risk',
    value: '14',
    icon: AlertTriangleIcon,
    iconColorClass: 'bg-red-100 text-red-600',
    trend: 2,
    trendLabel: 'vs yesterday'
  }, {
    title: 'Waiting on User',
    value: '28',
    icon: UserIcon,
    iconColorClass: 'bg-purple-100 text-purple-600',
    trend: 4,
    trendLabel: 'vs yesterday'
  }, {
    title: 'Resolved Today',
    value: '35',
    icon: CheckCircleIcon,
    iconColorClass: 'bg-green-100 text-green-600',
    trend: 18,
    trendLabel: 'vs yesterday'
  }];
  return <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-43">
      {kpis.map((kpi, idx) => <KPICard key={idx} {...kpi} data-id="element-44" />)}
    </div>;
}